import MD5 from "crypto-js/md5";

export function sendGAEvent(
  name: string,
  properties?: { [key: string]: string },
) {
  const propertiesWithDebugMode = { ...properties, debug_mode: true };
  window?.gtag("event", name, propertiesWithDebugMode);
}

export function identifyGAUser(id: string) {
  const userId = MD5(id);

  window?.gtag("config", process.env.REACT_APP_G_MEASUREMENT_ID, {
    user_id: userId,
  });

  window?.gtag("identifier", "user_properties", { identifier: userId });
}
